<template>
  <div class="sidebar">
    <div class="sidebar__inner">
      <div class="logo">
        <b-link @click="handleGoHomeClick">
          <svg
            class="large-logo"
            width="87"
            height="18"
            viewBox="0 0 87 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.1634 14.2203C4.11633 14.2203 3.20013 14.0182 2.41482 13.614C1.6426 13.1967 1.04708 12.6099 0.628247 11.8535C0.209416 11.0972 0 10.204 0 9.17379C0 8.40441 0.117796 7.71328 0.353389 7.10039C0.588981 6.4875 0.929282 5.96589 1.37429 5.53557C1.83239 5.10524 2.3821 4.77924 3.02344 4.55755C3.66477 4.32283 4.3781 4.20547 5.1634 4.20547C5.56915 4.20547 6.00107 4.25763 6.45916 4.36195C6.91726 4.45323 7.36881 4.61623 7.81382 4.85096C8.07559 4.96832 8.25229 5.13784 8.3439 5.35952C8.44861 5.56817 8.48788 5.78985 8.4617 6.02458C8.43552 6.24626 8.35045 6.44838 8.20647 6.63095C8.07559 6.80047 7.90544 6.91783 7.69602 6.98303C7.48661 7.03519 7.25102 6.99607 6.98925 6.86567C6.74056 6.72223 6.4788 6.61791 6.20394 6.5527C5.94217 6.4875 5.69349 6.4549 5.45789 6.4549C5.06524 6.4549 4.7184 6.5201 4.41736 6.65051C4.11633 6.76787 3.8611 6.94391 3.65169 7.17863C3.45536 7.40032 3.2983 7.68068 3.1805 8.01973C3.07579 8.35877 3.02344 8.74998 3.02344 9.19335C3.02344 10.054 3.23285 10.7321 3.65169 11.2276C4.08361 11.7101 4.68567 11.9513 5.45789 11.9513C5.69349 11.9513 5.94217 11.9253 6.20394 11.8731C6.46571 11.8079 6.72748 11.7036 6.98925 11.5601C7.25102 11.4297 7.48661 11.3971 7.69602 11.4623C7.90544 11.5275 8.06905 11.6514 8.18684 11.834C8.31773 12.0035 8.38971 12.2056 8.4028 12.4404C8.42898 12.662 8.38971 12.8837 8.28501 13.1054C8.19339 13.3141 8.02324 13.4771 7.77455 13.5944C7.32955 13.8161 6.88454 13.9726 6.43953 14.0639C5.99452 14.1682 5.56915 14.2203 5.1634 14.2203Z"
              fill="#222222"
            />
            <path
              d="M14.2882 14.2203C13.2542 14.2203 12.3511 14.0182 11.5789 13.614C10.8197 13.2097 10.2307 12.6294 9.81191 11.8731C9.39308 11.1168 9.18366 10.2235 9.18366 9.19335C9.18366 8.42397 9.30146 7.73284 9.53705 7.11995C9.77264 6.50706 10.1129 5.98546 10.558 5.55513C11.016 5.11176 11.5592 4.77924 12.1875 4.55755C12.8157 4.32283 13.5159 4.20547 14.2882 4.20547C15.3222 4.20547 16.2187 4.40759 16.9778 4.81184C17.7501 5.21608 18.3456 5.78985 18.7644 6.53314C19.1963 7.27644 19.4123 8.16317 19.4123 9.19335C19.4123 9.97576 19.288 10.6734 19.0393 11.2863C18.8037 11.8992 18.4634 12.4273 18.0184 12.8707C17.5734 13.3141 17.0302 13.6531 16.3889 13.8878C15.7606 14.1095 15.0604 14.2203 14.2882 14.2203ZM14.2882 12.01C14.7201 12.01 15.0931 11.9057 15.4072 11.6971C15.7214 11.4884 15.97 11.182 16.1533 10.7777C16.3365 10.3604 16.4281 9.83232 16.4281 9.19335C16.4281 8.24141 16.2318 7.54376 15.8392 7.10039C15.4465 6.64399 14.9295 6.41578 14.2882 6.41578C13.8693 6.41578 13.4963 6.51358 13.1691 6.70919C12.855 6.90479 12.6063 7.21124 12.4231 7.62852C12.2529 8.03277 12.1678 8.55438 12.1678 9.19335C12.1678 10.1453 12.3642 10.856 12.7568 11.3254C13.1495 11.7818 13.6599 12.01 14.2882 12.01Z"
              fill="#222222"
            />
            <path
              d="M22.7473 14.1812C22.2499 14.1812 21.8703 14.0508 21.6086 13.79C21.3468 13.5292 21.2159 13.1576 21.2159 12.6751V5.73117C21.2159 5.24868 21.3402 4.88356 21.5889 4.63579C21.8507 4.37499 22.2106 4.24459 22.6687 4.24459C23.1399 4.24459 23.4998 4.37499 23.7485 4.63579C23.9972 4.88356 24.1215 5.24868 24.1215 5.73117V6.74831H23.9252C24.0823 5.96589 24.4291 5.35953 24.9658 4.9292C25.5024 4.49887 26.1961 4.25763 27.0468 4.20547C27.374 4.17939 27.6227 4.26415 27.7929 4.45975C27.9761 4.64231 28.0743 4.94876 28.0874 5.37909C28.1135 5.78333 28.0285 6.10282 27.8321 6.33754C27.6489 6.57226 27.3348 6.71571 26.8898 6.76787L26.4382 6.80699C25.6922 6.87219 25.1359 7.08735 24.7694 7.45248C24.416 7.8176 24.2393 8.34573 24.2393 9.03686V12.6751C24.2393 13.1576 24.1085 13.5292 23.8467 13.79C23.598 14.0508 23.2315 14.1812 22.7473 14.1812Z"
              fill="#222222"
            />
            <path
              d="M30.7988 14.1812C30.3145 14.1812 29.9415 14.0508 29.6798 13.79C29.4311 13.5292 29.3067 13.1576 29.3067 12.6751V5.73117C29.3067 5.24868 29.4311 4.88356 29.6798 4.63579C29.9415 4.37499 30.3015 4.24459 30.7596 4.24459C31.2307 4.24459 31.5907 4.37499 31.8394 4.63579C32.088 4.88356 32.2124 5.24868 32.2124 5.73117V6.84611L31.9964 6.20062C32.2975 5.56165 32.7425 5.07264 33.3314 4.73359C33.9335 4.38151 34.6141 4.20547 35.3732 4.20547C36.1455 4.20547 36.7803 4.35543 37.2776 4.65535C37.775 4.94224 38.148 5.3856 38.3967 5.98545C38.6454 6.57226 38.7697 7.32208 38.7697 8.23489V12.6751C38.7697 13.1576 38.6388 13.5292 38.377 13.79C38.1284 14.0508 37.7619 14.1812 37.2776 14.1812C36.8064 14.1812 36.44 14.0508 36.1782 13.79C35.9295 13.5292 35.8052 13.1576 35.8052 12.6751V8.37181C35.8052 7.70676 35.6808 7.23079 35.4321 6.94391C35.1965 6.64399 34.8301 6.49402 34.3327 6.49402C33.7045 6.49402 33.2006 6.68963 32.821 7.08083C32.4545 7.47204 32.2713 7.99365 32.2713 8.64566V12.6751C32.2713 13.6792 31.7805 14.1812 30.7988 14.1812Z"
              fill="#222222"
            />
            <path
              d="M45.9892 14.2203C44.8505 14.2203 43.8688 14.0182 43.0443 13.614C42.2328 13.1967 41.6045 12.6164 41.1595 11.8731C40.7276 11.1168 40.5116 10.23 40.5116 9.21291C40.5116 8.22185 40.7211 7.35468 41.1399 6.61138C41.5587 5.85505 42.1412 5.26824 42.8872 4.85096C43.6463 4.42063 44.5036 4.20547 45.4591 4.20547C46.1528 4.20547 46.781 4.32283 47.3438 4.55755C47.9066 4.77924 48.3909 5.10524 48.7966 5.53557C49.2024 5.95285 49.51 6.46794 49.7194 7.08083C49.9288 7.68068 50.0335 8.35225 50.0335 9.09554C50.0335 9.34331 49.955 9.53239 49.7979 9.66279C49.6409 9.78016 49.4118 9.83884 49.1108 9.83884H42.9461V8.31313H47.8935L47.5794 8.58698C47.5794 8.05233 47.5009 7.60896 47.3438 7.25687C47.1868 6.89175 46.9577 6.61791 46.6567 6.43534C46.3687 6.25278 46.0088 6.1615 45.5769 6.1615C45.0926 6.1615 44.6803 6.27234 44.34 6.49402C43.9997 6.71571 43.738 7.03519 43.5547 7.45248C43.3715 7.86977 43.2799 8.37181 43.2799 8.95862V9.11511C43.2799 10.1062 43.5089 10.8364 43.967 11.3059C44.4382 11.7753 45.1319 12.01 46.0481 12.01C46.3622 12.01 46.7221 11.9709 47.1279 11.8927C47.5336 11.8144 47.9132 11.6905 48.2666 11.521C48.5676 11.3776 48.8359 11.3319 49.0715 11.3841C49.3071 11.4232 49.4903 11.5275 49.6212 11.6971C49.7521 11.8666 49.8241 12.0622 49.8372 12.2839C49.8634 12.5056 49.8176 12.7272 49.6998 12.9489C49.582 13.1576 49.3856 13.3336 49.1108 13.4771C48.6658 13.7248 48.1619 13.9074 47.5991 14.0247C47.0493 14.1551 46.5127 14.2203 45.9892 14.2203Z"
              fill="#222222"
            />
            <path
              d="M53.2892 14.1812C52.7918 14.1812 52.4122 14.0508 52.1505 13.79C51.8887 13.5292 51.7578 13.1576 51.7578 12.6751V5.73117C51.7578 5.24868 51.8822 4.88356 52.1308 4.63579C52.3926 4.37499 52.7525 4.24459 53.2106 4.24459C53.6818 4.24459 54.0418 4.37499 54.2904 4.63579C54.5391 4.88356 54.6635 5.24868 54.6635 5.73117V6.74831H54.4671C54.6242 5.96589 54.971 5.35953 55.5077 4.9292C56.0443 4.49887 56.738 4.25763 57.5887 4.20547C57.9159 4.17939 58.1646 4.26415 58.3348 4.45975C58.518 4.64231 58.6162 4.94876 58.6293 5.37909C58.6554 5.78333 58.5704 6.10282 58.374 6.33754C58.1908 6.57226 57.8767 6.71571 57.4317 6.76787L56.9801 6.80699C56.2341 6.87219 55.6778 7.08735 55.3113 7.45248C54.9579 7.8176 54.7813 8.34573 54.7813 9.03686V12.6751C54.7813 13.1576 54.6504 13.5292 54.3886 13.79C54.1399 14.0508 53.7734 14.1812 53.2892 14.1812Z"
              fill="#222222"
            />
            <path
              d="M72.1387 15.9808C72.3481 16.3198 72.4267 16.6263 72.3743 16.9001C72.322 17.187 72.1911 17.4217 71.9817 17.6043C71.7722 17.7999 71.517 17.9238 71.216 17.9759C70.928 18.0281 70.6336 17.9955 70.3325 17.8781C70.0446 17.7738 69.7959 17.5652 69.5865 17.2522L68.1925 14.9832C68.0224 14.7224 67.7999 14.5268 67.525 14.3964C67.2633 14.279 66.923 14.2203 66.5041 14.2203L68.8208 13.3401C69.4229 13.3401 69.9137 13.4445 70.2932 13.6531C70.6859 13.8617 71.0393 14.2203 71.3534 14.7289L72.1387 15.9808ZM66.5238 14.2203C65.1626 14.2203 63.965 13.9269 62.931 13.3401C61.9101 12.7403 61.1117 11.9057 60.5358 10.8364C59.973 9.76711 59.6916 8.52178 59.6916 7.10039C59.6916 6.01806 59.8486 5.04656 60.1628 4.18591C60.49 3.31221 60.9546 2.56892 61.5567 1.95603C62.1588 1.3301 62.8786 0.847613 63.7163 0.508567C64.567 0.169522 65.5029 0 66.5238 0C67.9111 0 69.1153 0.293405 70.1362 0.880214C71.1571 1.46702 71.9489 2.29508 72.5117 3.36437C73.0876 4.42063 73.3756 5.65945 73.3756 7.08083C73.3756 8.16317 73.212 9.14118 72.8848 10.0149C72.5575 10.8886 72.0929 11.6384 71.4908 12.2643C70.8888 12.8902 70.1689 13.3727 69.3312 13.7118C68.4936 14.0508 67.5578 14.2203 66.5238 14.2203ZM66.5238 11.6384C67.296 11.6384 67.9504 11.4623 68.487 11.1103C69.0368 10.7451 69.4556 10.2235 69.7435 9.54543C70.0446 8.8543 70.1951 8.03929 70.1951 7.10039C70.1951 5.66597 69.8744 4.55755 69.2331 3.77514C68.5917 2.97969 67.6886 2.58196 66.5238 2.58196C65.7646 2.58196 65.1102 2.758 64.5605 3.11009C64.0108 3.46217 63.5919 3.97726 63.304 4.65535C63.0161 5.33344 62.8721 6.14846 62.8721 7.10039C62.8721 8.52178 63.1927 9.63671 63.8341 10.4452C64.4754 11.2407 65.372 11.6384 66.5238 11.6384Z"
              fill="#222222"
            />
            <path
              d="M77.2609 14.1812C76.7635 14.1812 76.3839 14.0443 76.1222 13.7705C75.8604 13.4966 75.7295 13.1119 75.7295 12.6164V1.76043C75.7295 1.25186 75.8604 0.867173 76.1222 0.606369C76.397 0.345565 76.7831 0.215163 77.2805 0.215163H82.0513C83.5957 0.215163 84.7867 0.586809 85.6244 1.3301C86.4621 2.07339 86.8809 3.11009 86.8809 4.44019C86.8809 5.30084 86.6911 6.04414 86.3116 6.67007C85.932 7.296 85.3823 7.77848 84.6624 8.11753C83.9556 8.45657 83.0852 8.6261 82.0513 8.6261L82.2083 8.29357H83.0132C83.563 8.29357 84.0407 8.43049 84.4464 8.70434C84.8653 8.96514 85.2252 9.36939 85.5262 9.91708L86.7435 12.1665C86.9267 12.4925 87.0118 12.812 86.9987 13.125C86.9856 13.4379 86.8678 13.6922 86.6453 13.8878C86.4228 14.0834 86.0956 14.1812 85.6637 14.1812C85.2318 14.1812 84.8783 14.0899 84.6035 13.9074C84.3417 13.7248 84.1061 13.4445 83.8967 13.0663L82.012 9.60411C81.8157 9.23899 81.5735 8.99122 81.2856 8.86082C81.0107 8.73042 80.6704 8.66522 80.2647 8.66522H78.7726V12.6164C78.7726 13.1119 78.6417 13.4966 78.3799 13.7705C78.1312 14.0443 77.7582 14.1812 77.2609 14.1812ZM78.7726 6.47446H81.5015C82.313 6.47446 82.9216 6.31146 83.3274 5.98545C83.7462 5.65945 83.9556 5.17044 83.9556 4.51843C83.9556 3.87946 83.7462 3.39697 83.3274 3.07097C82.9216 2.74496 82.313 2.58196 81.5015 2.58196H78.7726V6.47446Z"
              fill="#222222"
            />
          </svg>

          <svg
            class="small-logo"
            width="35"
            height="32"
            viewBox="0 0 35 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <rect width="35" height="32" fill="url(#pattern0)" />
            <defs>
              <pattern
                id="pattern0"
                patternContentUnits="objectBoundingBox"
                width="1"
                height="1"
              >
                <use
                  xlink:href="#image0"
                  transform="translate(-0.00775235) scale(0.00657759 0.00719424)"
                />
              </pattern>
              <image
                id="image0"
                width="608"
                height="139"
                xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAmAAAACLCAYAAADGdyW4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAB8nSURBVHgB7d3rdds4GgbgT3P2/3gqCLeC8VQwTAXrrSDaCuKpwHIF9lQgp4JkKpC2AicVkKnAngreJUxwzdAgiBsvot7nHB4nkghCFAl+BEBgI2cIwEX151Ivv1ZLppcLvTSe9VLq5Vu1fFXLZrN5FiIiIiLqp4KuarmulgPSOFTLtloyISIiIqJXVYCUI13QZQ3GhIiIiOic6dqpAtMqGIgRERHR2UFd4/WIeRXVciVEREREa4a6j9cdlmUP9hEjIiKijo2sQBXkqKcZP0v9JOPSlNXyfrPZlEJERERU+UlOXBV8faz+PMoygy8lq5aiyue1EBEREZ26Kqi5wWm5ESIiIqJThdMLvhoMwoiIiOj04HSDrwaDMCIiojN2cp3wdfCyk3SaqYbUFEPf5XX6oWZaondS9+PKJa0/NpvNvRAREREtGeoxvlJ4qpZ7nd6F5/YfkG6A11yIiIiIlqoKVrIEgU+Bej5I56DLkp8UI+2rQDATIiIioiVCPahpTKCzkxGodHX6oQ5CREREtDSoa5tCqWmJMhkR4mvntkJERES0FJHBzYNMCHW/shCqBi26WZSIiIgoCYQPObGTGaBukjyZ/BIREdH0Fj0MBeqmQ9VHKhM/f242G6+pf3QNVFYtl62Xy2r5WqX1LB6qtNTwEh/Fj9rGP323RURERJQUwvp+OXdqV0EX6hq2w0CajzovmUfaQ2ma7ISIiIhoTvDv+1W4BEl4DbxCnl68gUN/LdR913zTfxIiIiKiuSBs0NWtQ7qXSDOeWOawrZAavFyIiIiI5gD/cb8eHdJUwVfMmF1tKp1Lh20e4GcvRERERHOAfy1VPpBeyuCrMRiEwb8mj82QRERENL2AoKUYSC/FNEa928ZAnzD414LlQkRERKv1kyzTYNNex+3A+zfiP5SFq6xa7gY+85f48f3+RERERHGqGqDP8JNZ0sowjdyShwu/pNgPjIiIaM2WWgOWeXxWDZRaWt6/kWlc9b2hB1f9Ku5yISIiotVaQxPkfwfev5JpfIC9L9hQPtsyISIiotVaXAAGj9HmtdKSVl79mWqSa7UdW+DoUwOm8v5OiIiIaJWWWAPmGzDZApupO7Pbtuc7x+MvQkRERKu0hgDMJpNpZZb3SvEzVc0dERERTewfsjxltTx4fN5WAzZ1EPOz5T3fGjAiIiJaqcUFYPqJxv8IERER0Uot9SnIVEqZ1nchIiIiGsAALC2vJx2JiIjoPM3SBKnHy2ovMb7qgU5NjjKt0QIwPTyHWspqebZ8ZyIiIlq40QOwKnBQQzPk1fKr1MM0ZJL+SUdjMKL6k1XbP8o0I8sPjcgfa1ctH5r/VN+rGV1f/VWDvB6r7bMGjoiI6ASMEoDpAVD/VS1bGflJxCroGOp3pSbCzmV8fw68n7rGSu3XXP/7ZbT/ar+XUtf6far2y1GIiIho3fSE0zfV8ojpPDrmq8C4CoddpPLis2/yzroP8FNUy1aIiIhocaI74UMHXtU/VRCyk2lHnx+cX1H3lRp7WItbx8/9JdPJqmWvA7FrISIionVQtTQYv3bJJvPI6z3GsfPIw4VHunlnXd8asK4CrBEjIiI6XTqQ+Ix57cUT4oOYrgfxBPdAMB8p73v4T3hOREREc8L8tV7Q288kANLVhN1LALj3Scs766UMHgvUT6cSERHR0lUX7Y+Y3xMia3Cq9bcIDyLV9rcSQeXfYft5Z53UtXcK+4YRERHNwHkYCtQd7Xcyr7Ja/h073la1vgpmjlIPk6HG1socVlOd+dVQE/exg6Dq8cneV/88OG57LHdVPn6u8uP6EMFioa7Ra8ZJ+3PkMdmITgrqwa9T1Hqrsq9MPRA09E01z9ua/r0+Sj3c0Dd1zRI6T6iHl5jbHvVBOcb3U82qO9T92g6oa6ce9f9Vk2UuI0DdHNnXJJp3PjtGDVjjRk4Y6hrFp9b3KTDSsUJ0aqpz4QrpFajLx23MuabP3UMn3bOvmcfbFhK2VpwjzBt8FagDlFX3V0JdCKmC7ND67nnnM2MGYMrJBmEwB7FXQkS+4w+GKFBfJ7wDMfQ/zJXLmUJ9Pej6IrQ6G9ub1Y+uqkCDOpv3KKUeqf2b/vdza+k62/kOm4Ks/f1RB6FNAXepl2Z6p1S21TY/yYlB/TTqh87L/2G1PVFdmyLTdHUoq+W9TzOiiix63vqjSifltedkoG6O7Q7uraaaey+0Kr19wPRBkOIEUPMTqgFI7881oPJl2k+deR6PzT/075RXi6rByiSOqkn6xjkliVbvKP4ysZcx6j1V2/beowxRZd1Fz+tE5wdppu85nHM18hwQ93Rno8CJ9Z+CuXl2K0Rk6k/kNHWaJb1cn3NFbBmCuu+taf1MzhTMTZAHofNQ/dh3CKc6Q7PD4IwQH4jdyQkBAzCiXkgcgHXS3vWUIc4DZavrBep+aiqfqk9YJmcMDMDOV/VDXyLc47mfPEuhT+KYzre5nAgwACPqhREDMJ1+XxDGJ5EDgAHY2TBNxv1Zwnyq2v1/O7VxXFBXp6sav4OpoNKv351SQKKo30H9HlKPXRbipIemIKJpVOXMTsx9yrZCRG5QN12F2MkJQd3H7QY/jh3losAJ1qyg/w51yFZOAFgDRtQLI9eA6W1cG85B7/l6iTVg56T7FGRIrccnfQfkBK8jMqvlnbw+AfNd6icmv45Zi6YvzHdifvJmSFYte9RjZt2OOcyB3k9Xepvv9MvqyaCX/VRt++ialvp9UDcNfxA/6ns+CBGR3dHwWiZENAxhtV8F3J92aZr6XGqdDkhcg4G61muPtO6QsJ+DzuM1fhyQtU+hv0/mkXZIn7BcFg6sASPqhWlqwFhrkwj35RmC20W/K3NIV134PyNMgQQBAMKDDxcq3eggDHWAWiDMHm6/RXfKHheLP/HBAIyoFxiAnRTuy/Px0gkfr4N5+rgdaipEHTw9St2UFiKrlgMipslBHRypg3es6YxUugfEzYemmkRjJube6jxktg/p38u3U36OM32aCa+1tp/1RUwtT3h9OGOPuuY4kwh47ZN40EsmEXQBrvL2CL9a0vZ6dwOfu9afPbT2x6Xhsxd6H1rzovf1TWtfN/v5Uae9w0hTkrW+j+139irDdJrN9x7lgZYq3Y+t/GUyL1MZ8bc4QP3k/WfffaWPmWb+3o89n7nQ52hzXBd1PPPDfL/R57AlfzeW42o31e+m90PeOiZN59h1grLnYyu9zJKXK7yWrY8YKHNWDf7Nj4N3UNVnPiCtoB8H6Zsd+wR1OE2cP3VCXQ5sL2SQ3UWP64bENWAIe0Bjj8DCC2/H3YsdKHPfSc/p7hlva4l3nfdVAX6w7IPCNy8OaXapz2aSQMC2CzgGCHh7ju0kIbwtsw8eeRmjBsx0DRksN2Auj7YO66kAt3uO5p10b+B3HicJlOF/XO3ROqaRsAYscD8cEHCO4e0xUATkJZdzA//mx+1AejFjidl4nSAIf6oz1NYzfzED3vZRB3c2sN1rzzQXXf2NRAEY4sdOU7wLcZjPv3cSCG8vaE+O63UdWu+5HKtPDnkpWu/dIIw6xkNr1du1cqEKDJ9jpjyn7C966G7A8tmim39JDOabusxhvdyw3uDNbM96O/1ezHkc1aUE4cfV/wcwR6IADHHdWhTf662pHH6n37uCWxAYfF6fLPgpBtJSB0+B8Tj9QBPkw8S5kEVdVTuWwpYP1BcgnzuipBeP1JAgAEN90+Bb69XHq7YW4wdgcFyv66Bf38PNvUNeCv167M3HYG1vz3d0uTgXrcX2mcyynYNhnSQ1yfAMWjD+QKw3PvnprJs0AEOacj+0tmmPeB+QIADD8PWlaX4sYC/3fJqEjQEY6uDLRYFzG8gd5gPZZj+Q3h7jKuAQDMC/lieVnUPepggOdwN5uPdLbrlVw4gMwGAPvg6ojyX1mUwv6t9XPdttOAdhWHAAhv5aqqZP173eP7ljXtT/uxeHJ7z2p2v2s/qryqYd+s8V34uSrfl9b/oOeO1DZFpPvXbRsy1TuZok8IG5jM0tny/GyIdO+8aQl8Fa+Nb6qQOwwpAX9bo6X33OX69gGfYbigP0OdLKQw7zE+9PMH8352Md/cFXobd5YVjn0rI/nPZFz/o5zGVrgbr/1x7177PFOfY1hn+gklvSyjCNncP3KjCPweYeTNMvzVprBf/Ae7H9wBARgKE/GH4pCB3X/9yzz1xraw+GdZcQgBWG/xsLcI+8PHVe+wy3G6q+i0MujmA+7wo41qTBPKCxrebpEJPfnjS9a0eQfjLupkP3AWbOzUhIG4AVrX87zUkMy/kvjtDf1UWlmzusf9nJgyk/rv04M5gDnnuP9U3bHzxHYD5HD53/74Ez7OfVB/a7gDcG0tpjGk8D+fANLlLLB/JXYBo7Sx4u/JJa7qjWiAvA9oZ1C3hWhffkwanpFssNwNoeEHCHCvuxvvNM62BIw7Wpy3SRLOD/O5tqjnOPbUb1p4T5eN0OrFN0Pt/UCvksd3h9krCvttjppqWTt5QBWKOAx++K/j7LueP6hWFdr75kGG4VcQ3ATGnsxAPMQdzg9mGPJQow8HoLnk8gDaRVYDq5JR++zWup3Vvy5toensLQ7+XTUXWxHfERGIChv8Y2pG9R31hzO4d1D4b1lhSAPUogWJr8xBPMF13XBwxM+cgkgCEtn/5XSi4BYL4wujyRXmB8e4Q9OTdGABZy/ppqsXcO620N6xWB+8L0+zZcAqBtyL70SOvdwDq2ACwTekONA5Z5fL53XBe9gzOZju0k+1XmZdt+LtNRhZTtLuybuMtkfUwdTB82m81X8VSt81z9+cPw1kc5ff+WtNS+uhVPevqt587LFw4XhlzeHr8PEVOedcfSu7KcZ58Mr32QMLm8HW/Lez+O4IvUU9KVMr+g81fMv5NLIGcqQ25D9kXgOI1tpuMq6PjQ0+x1z7X/SJjbhRwbi6MCMJ9mBduBPdZAp31sQc7UeenKLO9NHRxmlvdKcbfGDpK54bXgC5oOEI6dly9w2lXvDyMUnl8i0jwaXvun2JkuTJ8k3EPn/838tiaqNrx7IdsirMNx92JfjjkfrQfV5+sQWvOTWGgAY7q2Wctq1DVtWefl2N/EdLwMgnkw9WPkuds9R34Xf6XU34kM1GTcPgWB7cCY+gKdWd6bO1jIAt8bgyok+gJnnxN9VQFYT+GZYiL4v+RtQaguUEc5TTGBSp+/JJypFn7o2Mw7/y99JrPvUrWd1fGjzql20KX+fez5rAoKusHTdbXsxBHqJvWs83LozYI6730DFbWPf9Z/MzEHnOp1FYTtqu89R81cGVj79VL7BLeW+rbc8NpRIrSOrVz85IbXYs4z5Sg/1uCHVGwcdesAGfzD8/O2HZkJnZpzPjEyw2tBhXfH0fBayJ3jIsQEKhbBfcrEXGtre9rXFGj7NL33UWm0L0i22hJVA6AuZO18qqEC7j0uTm9qvyT8Yv9cbXcnEXQNnrqxUPnKOm/vqvf/rrYxdc1HKdMyndexQU+TRi5+/mV47ShxuuXhS3N/9bt+F3cpzrXV+snz87Y7zVJoiZZUa7kkpru5FIVFaXgtk9NUygg8C/BYmeG1FIG2882LDrK6NU7q3Nu6rN/Thy2mGTea+k6qqa1aVPOvqbbrZobmyFKmdTFSHkrxlyVKp810jP8iflKca6ulArBUzVBT16bYJnotZV62fTH1AZkqAFtbbVlmeK2USPpia+oofs7B7pwyw2s3iCRvH67IxO7B8JrrAxqmz8V01k5K16aZAszFDl2TSGZ4rZR4pfjLDK9Fzeyh1jekyXIsId8AzPa00dSBhW17pczLlrcp7/4VW158Hgg4h+bKVN/RlM7PQnOY6oJhuyFsnnD70nk5w/CYgZnUTX1tD5uFPVVW5eda3pa7Q09hr06i/k4haUy1n8/hOjAZFYCVHp+/7HtDFwilTOdoeW/udmfb9r/IdIY6QPqctKUQkYk6xx4cPmeqtboZWMc4zIEsk+mBja3QWhxDH3IgM9UJ36dGRo0YfGG5qKsTcKhASWHoKSYV5Mw5/pItyFIHsNp/U9yxDD3Blou7UijG30JLocZrS3kj9OxS86HKrKr8PMqP552qJcpN5Zmu/dp2Xl5c7VeL2qfd8n/uMRknNXB9nFJZLe8lIY7llZ4KwFRA4DMwoPFxa+1epgnArHeAuqCbKsjpsgaHlsfSk+dDLLWE8B+bam1Ps5gKyUzSyLov8FHs2ZSmF2e8mKiyK++8psrfo+GzyQbWnEiKTtunpK+rQey5nom/srNexoBp+VQTpG+V4lXfGz1P+6TmOtDdXJ1UXbarAtWxL8ifBk5A39G411b1XBpeyyQSzNOgTL3vMqGG6TybrVamZ7DevoFZt53/H5d8Ue3J25r7PppuSn+TeCEVB2+Oc0RMZ0bTaAIwn2Dgw0DHyp2M21zlegc4RZDTVYpD04YOVMe8ky0dxvnJxcNI40GNaei3NwVFlxIvM7w22YMX4JxrXabfOZd5mc796/Z/kHbg1Umc4bE3VhnyL/H3X8NrSZsgKb2fdDDgc4duHb9Gp6fmjhsj+Ll1rP2aIsgxcZ7zSg9SOMYo4+p7W0+8nsLd5ijLZrrLdgnAup/5PcFTW6bCcygoT3mu5EL/1/NwUDbn03n6ZqbsvPyxkyfTtENHWbbM8Fop62W6bqYYdDkXf2PlhUbUDMTqO3rvR1sBpp+U+EPS+uQ7evOIQY7JnxvPOcCqz28lbf5egi+HINC3/9lU+zBUZnjNGtT03HioYzqXOLnhtaPYmTroh969htw9r52pfLuWeZnGzXrJU1W2XsmJ1X5ppm4Nqx0JvWdy+BwRc7/CPOiuC9NN3tW5DQNyapoA7EH8ZDJQgOlgRLWHlxLvVgcrIVQ+fWr4Qqj0dxJAf68U/dVKqYMv63etTkjT1CFDjrJQutnjTbX/xu1x6ZBhAWx5Me1bl347SZoyesaMIvPF6ePMF6cHeXvxbgKY7hPcrv1eZwPzZNDKUdbNdHMa84DVnQTQN5THzsvq+J7ioTiKVZ1AB/h5cmnzV5+plgeEKWLuJlp5UCORP2IcKt3ogrxKY6u/b4h7lzyg/i18HWTBqvztY/Lcs8+9C0HLvs0d1s0N6z3B47jS2y968uA0y7BhtUIimfIkEarVd4Z8bh3WOxjWizq29e/2GQHHi17f+F1Cvt/Adgok/l076feVr4NzfsJ87A+OoB+63kCa8N1P6D/vvWtYq3Vu0G/wWO3ZJ0ougVD/tjeoz5984LMPKbd9Viw/no1z8IHXQMxleoQDIgsdw/bVgXSPtB6Q+C4adQHsEiw+6e+TOaarvn8Bf1tZqCpvH2LzjP7j3vnOsfrsZc++db4gwHxeOF3YUZ9b1mPGMZ2uNQVgWc8+VgFUJh5QHzOHTjohF9wLDJeHY/wGyQIwvS/6jr2t4/pdJxOA6fX6rivOx0T12Y+t9UzHhNPNQk9enuBZjuM18Grn5WlgHQZgMRB2gfY+6FGfPNf6YNnrRRWsKvgYtVkAcTVNDXVQjtrUg/qCcaX3y14v93q/5eIJ5pqiIUnvlFNAXTCYLoDBeUZ/Afpo29d4LaSM+YDHhR3mwELpDRBgLiQLGC6IjnmI3peGNIuQvFjSCwrA9LrX6P+tBsse2I+7oD5l6P/dGzuJBEMAhrp8CVnUzYYql+5gbzW5d8zbGgIw283tHvYyxHRMmY4J1wBsKC+XDuvfwBwEMgAbE8zV3y5Oqp1ZH2QhgZg6KNXJcVIdG2Gv2rbZyoz079QU9AXcfq+tBIC9mfxJ52HfWoqBz2ee2x+qoSxaefhs+ewVDBdGxzy82aZEwoICMMv6bQe83hDuWvvbVlNVIHAIBtS/u00mkRB/w+nrwSNvJx+A6XVVcFpY9ol674DX8qPvHD7A3Kzp063CJS8vTeeoj/E7naehlpfdwHYZgMWCf1+wRlA/iLmhPpHv8XqRR+dAPej3czlBCKv5evnuMjP4NxnvJALSNFEXCL8Yq9oFlyb6Ps1TdIfuG47bf/NdJBIWFoDpNK6RjrpoZRIB/cF/VEDRSr/AdLxqArGSAEyvPxT4DHnp0oPIAKyVl5T9ngd/VzAAi4ewvmCN6MKI0kD8Cej9FN4I3+HBMa8FEp3oiGuijq4dRVghXrS/P+q72x/ed9x2N/iLfgADb4/Bp4jk+oKnXDwh7uGgZp9vJQH0l7mZJIDwm2pXXv1RO3kzBRuDzZeob1a6dhIBb8+7wYcIDGmEHlf/f5AK5lrRLxIA8V1u9nDvZ2y6gZ39OnJyEFcTUGDBHbfPAeoOnTE1KU79N8YG+81AgYH+FZHbVgXXAcNUPqIDr57tDwXQj6Zto26GbNs5brMb3ET3czSkuZMIeNtU632R7KTXXDALDGsCjVwSgjkISVL71Uo/VW3IE16bsF72BeJvOj530s8c1zu01isQXxOZ7FhFHSA+wF4Oq/f2MBxP+LGm17tLgyE91/IM+nPXvr8r3t48LvoJ+iXYmF7UO14VbJmEK8Vj5HqKp09k1R8vl3Bltfy2lMmj8eM4XypPpfo7Zf70fr2QH+doexl3Z+x86HNRff+ss+2vtvHF9H5TS+kzf2Brva+pvlsrzWfH8dlc0sxTpqfTNO1rZXB/R25XBVvbzsv/XPK8j6m1ghCv4y50PUt6mQScNwNpNsdUu/z46jBmY976bLJypic/L9uR+nsHb6t1DiU9N88O4vujNArU0XcmlBxen1pJdYebCRFNAubar6DmJiI6LRvbm6ibEpNVhUsdYavlm7yO/v1DpAxd7bmUGpip6e/fXrrUa1m1/Cp1TVcm6fyhp28iognAXPv1/gQnvyei1DD82HasfWd7eeu9A86g9gx1baN6FLjAfHZCRJOBufYrqk8bEZ2Ofwx9QE2AjfrJ8TnG+sr1IjpA+HOMmjHUbe1qEuNMXtvGS6n7fqjauuMYd6Soa7vU8B1bmdet70TnRBTtg+G1FPPCEtGaYLyaMFsNWFeBdI9m20b87dv2TcLt901fM7WdENHkMPIcjUS0Ikg7gGHDJwB7KaQQ/0huzDANBeInx82Q5gGHWNdCRJPDCJNuE9HKIX3NjW8ABr39oLFnUPe1SiFo5H/Ej5acQgGOUEw0G7D2i4hCIH4U6baQAEzxDoAQPi2PU95nyoMvNehhUPBKRPHwdqBcZStERK4QP82BEhqAwSeQQPiE1EOcA0GYn3qaSgHWehHNDm8DMHVuZkJE5At137ACYWICsJ1j/rYYV+6YjxSTPftSfc3UAxSs9SJaiFZZoM7PrRARxUBYjVhMAOY0Zg7G73PlOtlxytnphxjnCSQiIqKVQh1EqT5ihUOgEBOAYSjAwPi1X42tw34Z2yiTBRMREVFagwOxhtCDlqqlmfgzr5bfpR7g9FLMU+yE+lnqAVP7fJRpqEEVH/reRPo+Hs3E1M3UTkdOfkpERHQaNjIDvM53mEln1nlde3MQd1m1/vee7WTVnykf7/6lb6R+vM4SH+O5Wc51rkwiIqI1GKUGbIgOHpoanDHFBjy+rqSnFkx/56MQERHR2ftJ1m3qACwTIiIiogFrD8AymdY7ISIiIhowSxPkOdJ9wHxG779t940jIiKi9VhDAPZLtXzveW/qjup/W95TzaFbcfdJxu8jR0RERDNYYhOkb9CUWd4rZVqlpMOnHImIiFZqDQGYbUyxqcfFsm3P94GAJyEiIqJVWlwAFtDvyRbYqIBoqpqkZz0AbZ9MPPSNbUZERESnb6lPQZYen/297w099tYnmcaXgfd/F3cc0Z6IiGjFlhqA/dfjs5ewzwc5FBilctv3hh6R36cJkrVfREREK7bUAMy3Bmjb94ZuFhy7FuxhoOk0Fz9HISIiIpqSmg8Sfg4D6V1US4FxFBiYaBv+286FiIiIaGpVEPIEP/lAepcBaQ5R6V0ObNc3mJxy8nAiIiKiV1Ug8gA/B4c0UwZhg8GX3uYj/OyFiIiIaA7wrzlStg7pZohvjizgFnxt4S8XIiIiornAv7ZKfT5zSFf1CdvB35Ne78JhGyGBHpsfiYiIaF4IC5IO4kgHSaqWaqiZ8ADHwKuV9gH+tkJERESrt5EF0wGPqhVyDny0+81m84fPCnpbqlkxa72shsMo9YCuPmndVX+uxU9ZLe8DZgIgIiIiSgthtWDKjcxAbRdhdkJERES0BKj7a4U+uXgnE9H53CNMAYe+a0RERESTQdjThJMFN6j7kvkON9G2FSIiIqKlQVin9oaqQRulSRJ1k2PM2GIc94uIiIiWCXUtU+wgqgUS1Dahbm68RprxxDIhIiIiWiqEDc7aF/js4THoKeqgS23/DulG03fePhEREa3HooehMKmCFjW8Q+rO9Ueph4H4Xi3PernQyzt5HZ7CdzgMm9vNZrMTIiIiolOA8KEplmInRERERKcGpxuE7YSIiIjoVOH0grCdEBEREZ061E8jngLfqYmIiIhopU6uE74J6qEc1CTcmSxPWS3/3mw2X4WIiIio8pOsgJ7A+n21fJJl+bNafmPwRURERKtW1YZdIX6A1FhqWqJciIiIiM4J6vkjC0yrAOd1JCIionOnA7EDxnUAa7yIiIiIfoR6LslUwdiTTkc9gZlydHwiIiI6A6t4CtKXDpou9fKr1E9PqqWZfqjRTEtU6uVbtagO9V83m82zEBEREQX4H4/kdxTramrUAAAAAElFTkSuQmCC"
              />
            </defs>
          </svg>
        </b-link>
        <div class="hide-icon" @click="hideSidebar">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.7071 6.29289C12.0976 6.68342 12.0976 7.31658 11.7071 7.70711L7.41421 12L11.7071 16.2929C12.0976 16.6834 12.0976 17.3166 11.7071 17.7071C11.3166 18.0976 10.6834 18.0976 10.2929 17.7071L5.29289 12.7071C4.90237 12.3166 4.90237 11.6834 5.29289 11.2929L10.2929 6.29289C10.6834 5.90237 11.3166 5.90237 11.7071 6.29289Z"
              fill="#222"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.7071 6.29289C19.0976 6.68342 19.0976 7.31658 18.7071 7.70711L14.4142 12L18.7071 16.2929C19.0976 16.6834 19.0976 17.3166 18.7071 17.7071C18.3166 18.0976 17.6834 18.0976 17.2929 17.7071L12.2929 12.7071C11.9024 12.3166 11.9024 11.6834 12.2929 11.2929L17.2929 6.29289C17.6834 5.90237 18.3166 5.90237 18.7071 6.29289Z"
              fill="#222"
            />
          </svg>
        </div>
        <div class="show-icon" @click="showSidebar">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.2929 6.29289C11.9024 6.68342 11.9024 7.31658 12.2929 7.70711L16.5858 12L12.2929 16.2929C11.9024 16.6834 11.9024 17.3166 12.2929 17.7071C12.6834 18.0976 13.3166 18.0976 13.7071 17.7071L18.7071 12.7071C19.0976 12.3166 19.0976 11.6834 18.7071 11.2929L13.7071 6.29289C13.3166 5.90237 12.6834 5.90237 12.2929 6.29289Z"
              fill="#222"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.29289 6.29289C4.90237 6.68342 4.90237 7.31658 5.29289 7.70711L9.58579 12L5.29289 16.2929C4.90237 16.6834 4.90237 17.3166 5.29289 17.7071C5.68342 18.0976 6.31658 18.0976 6.70711 17.7071L11.7071 12.7071C12.0976 12.3166 12.0976 11.6834 11.7071 11.2929L6.70711 6.29289C6.31658 5.90237 5.68342 5.90237 5.29289 6.29289Z"
              fill="#222"
            />
          </svg>
        </div>
      </div>

      <!--    <br><br>-->

      <ul class="sidebar-nav">
        <!--- My Collection -->
        <create-focus
          :id="addFocus"
          :key="refreshKey"
          @focus-created="refreshKey++"
        />
        <li
          class="li-link"
          @click="handleGoToMatchGameClick"
          :class="{ active: $route.path == '/app/myapps' }"
        >
          <a>
            <img src="@/assets/matchgame-24.png" /> &nbsp;&nbsp;
            <span class="menu">Match Game</span>
          </a>
        </li>
        <li
          class="li-link"
          @click="handleGoToSimonGameClick"
          :class="{ active: $route.path == '/app/myapps' }"
        >
          <a>
            <img src="@/assets/simongame-24.png" /> &nbsp;&nbsp;
            <span class="menu">Simon Game</span>
          </a>
        </li>
        <li
          class="li-link"
          @click="handleGoToTicTacToeClick"
          :class="{ active: $route.path == '/app/myapps' }"
        >
          <a>
            <img src="@/assets/tictactoe-24.png" /> &nbsp;&nbsp;
            <span class="menu">Tic-Tac-Toe</span>
          </a>
        </li>
        <li
          class="li-link"
          @click="handleGoToSliderGameClick()"
          :class="{ active: $route.path == '/app/myapps' }"
        >
          <a>
            <img src="@/assets/slidergame-24.png" /> &nbsp;&nbsp;
            <span class="menu">Slider Game</span>
          </a>
        </li>
        <li
          class="li-link"
          @click="handleGoToPhraseGameClick()"
          :class="{ active: $route.path == '/app/myapps' }"
        >
          <a>
            <img src="@/assets/phrasegame-24.png" /> &nbsp;&nbsp;
            <span class="menu">Phrase Game</span>
          </a>
        </li>
        <li
          class="li-link"
          @click="handleGoToPhotoAlbumClick()"
          :class="{ active: $route.path == '/app/myapps' }"
        >
          <a>
            <img src="@/assets/photoalbum-24.png" /> &nbsp;&nbsp;
            <span class="menu">Photo Album</span>
          </a>
        </li>
        <!-- Discover -->
        <li
          v-if="false"
          class="li-link"
          @click="handleDiscoverClick"
          :class="{ active: $route.path == '/app/library' }"
        >
          <a>
            <img src="@/assets/compass-2-24.png" /> &nbsp;&nbsp;
            <span class="menu">Discover</span>
          </a>
        </li>
        <!-- Blog -->
        <li
          v-if="false"
          class="li-link"
          @click="handleBlogClick"
          :class="{ active: $route.path == '/app/blog' }"
        >
          <a>
            <img src="@/assets/newspaper-24.png" /> &nbsp;&nbsp;
            <span class="menu">Blog</span>
          </a>
        </li>
        <!-- My Journeys -->
        <li
          v-if="false"
          class="li-link "
          @click="handleJourneysClick"
          :class="{ active: $route.path === '/journeys' }"
        >
          <a>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0)">
                <path
                  d="M5.20308 19.2803C6.17203 19.2803 6.99629 19.9541 7.29047 20.887H20.2969C21.5634 20.887 22.5937 19.7834 22.5937 18.4268C22.5937 17.0702 21.5634 15.9665 20.2969 15.9665H15.7969C13.7549 15.9665 12.0937 14.1872 12.0937 12C12.0937 9.81284 13.7549 8.03347 15.7969 8.03347H19.7095C19.929 7.33727 20.4438 6.78587 21.0937 6.55074V4.71967H17.2969C16.9085 4.71967 16.5937 4.38246 16.5937 3.96653V0.753138C16.5937 0.337205 16.9085 0 17.2969 0H21.7969C22.1852 0 22.5 0.337205 22.5 0.753138V3.96653V6.55074C23.3709 6.86586 24 7.74874 24 8.78661C24 10.0878 23.0117 11.1464 21.7969 11.1464C20.8279 11.1464 20.0037 10.4726 19.7095 9.53975H15.7969C14.5303 9.53975 13.5 10.6434 13.5 12C13.5 13.3566 14.5303 14.4603 15.7969 14.4603H20.2969C22.3388 14.4603 24 16.2396 24 18.4268C24 20.6139 22.3388 22.3933 20.2969 22.3933H7.29047C6.99629 23.3262 6.17203 24 5.20308 24C3.98826 24 2.99995 22.9414 2.99995 21.6402C2.99995 20.3389 3.98826 19.2803 5.20308 19.2803ZM21.0937 1.50628H18V3.21339H21.0937V1.50628ZM21.7969 9.64017C22.2363 9.64017 22.5937 9.25727 22.5937 8.78661C22.5937 8.31595 22.2363 7.93305 21.7969 7.93305C21.3575 7.93305 21 8.31595 21 8.78661C21 9.25727 21.3575 9.64017 21.7969 9.64017ZM5.20308 22.4937C5.64248 22.4937 5.99995 22.1108 5.99995 21.6402C5.99995 21.1695 5.64248 20.7866 5.20308 20.7866C4.76367 20.7866 4.4062 21.1695 4.4062 21.6402C4.4062 22.1108 4.76367 22.4937 5.20308 22.4937Z"
                  fill="#222"
                />
                <path
                  d="M5.20336 4.82031C6.41818 4.82031 7.40649 5.87892 7.40649 7.18014C7.40649 8.48137 6.41818 9.53998 5.20336 9.53998C3.98855 9.53998 3.00023 8.48137 3.00023 7.18014C3.00023 5.87892 3.98855 4.82031 5.20336 4.82031ZM5.20336 8.0337C5.64277 8.0337 6.00024 7.65081 6.00024 7.18014C6.00024 6.70948 5.64277 6.32659 5.20336 6.32659C4.76396 6.32659 4.40649 6.70948 4.40649 7.18014C4.40649 7.65081 4.76396 8.0337 5.20336 8.0337Z"
                  fill="#222"
                />
                <path
                  d="M5.20311 1.60669C8.07215 1.60669 10.4062 4.10681 10.4062 7.17991C10.4062 8.83938 9.73129 10.3855 8.54878 11.4484L5.82955 17.1621C5.7095 17.4144 5.46749 17.5732 5.20311 17.5732C4.93873 17.5732 4.69672 17.4144 4.57667 17.1621L1.85744 11.4484C0.674925 10.3855 -3.05995e-05 8.83938 -3.05995e-05 7.17991C-3.05995e-05 4.10681 2.33407 1.60669 5.20311 1.60669ZM2.85232 10.3739C2.93192 10.4412 2.99693 10.5261 3.04301 10.6229L5.20311 15.1618L7.36321 10.6229C7.40924 10.5262 7.4743 10.4412 7.5539 10.3739C8.47293 9.59658 9 8.43243 9 7.17991C9 4.93737 7.29674 3.11297 5.20311 3.11297C3.10948 3.11297 1.40622 4.93737 1.40622 7.17991C1.40622 8.43243 1.93329 9.59658 2.85232 10.3739Z"
                  fill="#222"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="24" height="24" fill="#222" />
                </clipPath>
              </defs>
            </svg>
            <span>My Journeys</span>
          </a>
        </li>
        <!-- My Focus -->
        <li
          v-if="false"
          class="li-link"
          @click="handleMyFocusesClick"
          :class="{ active: $route.path == '/focus' }"
        >
          <a>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9999 0C11.5859 0 11.25 0.336045 11.25 0.750045V2.02807C6.33257 2.39438 2.39431 6.33259 2.02794 11.25H0.749913C0.335918 11.25 0 11.5861 0 12.0001C0 12.4141 0.335918 12.75 0.749913 12.75H2.02794C2.39425 17.6675 6.33253 21.6058 11.25 21.9721V23.2501C11.25 23.6641 11.5859 24 11.9999 24C12.4139 24 12.75 23.6641 12.75 23.2501V21.9721C17.6674 21.6057 21.6056 17.6674 21.9719 12.75H23.25C23.6639 12.75 24 12.4141 24 12.0001C24 11.5861 23.6639 11.25 23.25 11.25H21.9719C21.6056 6.33263 17.6674 2.39444 12.75 2.02807V0.750045C12.75 0.336045 12.4139 0 11.9999 0ZM11.25 3.53345V4.25004C11.25 4.66404 11.5859 5.00008 11.9999 5.00008C12.4139 5.00008 12.75 4.66404 12.75 4.25004V3.53345C16.8398 3.89272 20.1073 7.16025 20.4665 11.25H19.75C19.336 11.25 18.9999 11.5861 18.9999 12.0001C18.9999 12.4141 19.336 12.75 19.75 12.75H20.4665C20.1073 16.8397 16.8397 20.1073 12.75 20.4665V19.75C12.75 19.336 12.4139 19 11.9999 19C11.5859 19 11.25 19.336 11.25 19.75V20.4665C7.16023 20.1073 3.89259 16.8398 3.53332 12.75H4.24991C4.66391 12.75 4.99995 12.4141 4.99995 12.0001C4.99995 11.5861 4.66391 11.25 4.24991 11.25H3.53332C3.89259 7.16023 7.16023 3.89269 11.25 3.53345ZM11.9999 9.00002C10.3459 9.00002 9.00002 10.3461 9.00002 12.0001C9.00002 13.6541 10.3459 15 11.9999 15C13.6539 15 15 13.6541 15 12.0001C15 10.3461 13.6539 9.00002 11.9999 9.00002ZM11.9999 10.5C12.8269 10.5 13.5 11.1731 13.5 12.0001C13.5 12.8271 12.8269 13.5 11.9999 13.5C11.1729 13.5 10.5 12.8271 10.5 12.0001C10.5 11.1731 11.1729 10.5 11.9999 10.5Z"
                fill="#222"
              />
            </svg>

            <span>My Focuses</span>
          </a>
        </li>
        <!-- Add A Book -->
        <li v-if="false" class="li-btn">
          <button
            type="button"
            class="white-btn"
            @click="$bvModal.show(addFocus)"
          >
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.5001 3.33333C10.9603 3.33333 11.3334 3.70642 11.3334 4.16666V15.8333C11.3334 16.2936 10.9603 16.6667 10.5001 16.6667C10.0398 16.6667 9.66675 16.2936 9.66675 15.8333V4.16666C9.66675 3.70642 10.0398 3.33333 10.5001 3.33333Z"
                fill="var(--theme-color)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.83325 10C3.83325 9.53977 4.20635 9.16667 4.66659 9.16667H16.3333C16.7935 9.16667 17.1666 9.53977 17.1666 10C17.1666 10.4602 16.7935 10.8333 16.3333 10.8333H4.66659C4.20635 10.8333 3.83325 10.4602 3.83325 10Z"
                fill="var(--theme-color)"
              />
            </svg>

            <span>
              Add Book
            </span>
          </button>
        </li>
        <!-- Joins -->
        <li
          v-if="false"
          class="li-link"
          @click="handleMyJoinsClick"
          :class="{ active: $route.path == '/joins' }"
        >
          <a>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0)">
                <path
                  d="M1.38519 22.5984C1.88674 23.0951 2.49233 23.4763 3.15912 23.7151C3.8259 23.9538 4.53751 24.0442 5.24347 23.9798C6.42321 23.8511 7.52029 23.3172 8.34454 22.4706L13.7334 17.1286C14.5006 16.3879 15.0205 15.4321 15.2235 14.3897C15.4164 13.403 15.2859 12.381 14.8512 11.4731C14.4164 10.5651 13.7001 9.81882 12.807 9.34317C12.7016 9.28261 12.5837 9.24652 12.4622 9.23764C12.3408 9.22876 12.2189 9.2473 12.1057 9.29189C11.9925 9.33647 11.8909 9.40592 11.8087 9.49502C11.7265 9.58412 11.6658 9.69054 11.631 9.80629C11.5781 9.98802 11.5919 10.1825 11.6701 10.3551C11.7482 10.5276 11.8857 10.6671 12.0579 10.7485C12.5936 11.0396 13.0348 11.4757 13.33 12.0058C13.6252 12.536 13.7623 13.1385 13.7253 13.7429C13.6554 14.5819 13.277 15.3663 12.662 15.9468L7.20085 21.3607C6.61069 21.94 5.82738 22.2857 4.99821 22.3327C4.16905 22.3798 3.35108 22.125 2.69809 21.6162C2.30909 21.2764 2.00862 20.8485 1.82212 20.3689C1.63561 19.8893 1.56864 19.3721 1.62685 18.8614C1.7257 18.0927 2.08994 17.3817 2.6578 16.8491L7.6841 11.8664C7.83412 11.7168 7.91833 11.5145 7.91833 11.3035C7.91833 11.0925 7.83412 10.8902 7.6841 10.7405C7.53318 10.5918 7.32901 10.5083 7.11621 10.5083C6.9034 10.5083 6.69923 10.5918 6.54832 10.7405L1.55433 15.6913C0.697933 16.5076 0.156514 17.5952 0.0238599 18.7656C-0.0464324 19.4643 0.0390413 20.1698 0.274283 20.8321C0.509525 21.4945 0.888812 22.0975 1.38519 22.5984Z"
                  fill="#222"
                />
                <path
                  d="M9.83501 13.6392C10.1872 14.0177 10.5978 14.3384 11.0514 14.5894C11.1552 14.6425 11.2694 14.6727 11.3861 14.6777C11.5029 14.6827 11.6192 14.6624 11.7273 14.6184C11.8354 14.5743 11.9324 14.5075 12.0118 14.4225C12.0912 14.3375 12.151 14.2365 12.1871 14.1263C12.2453 13.9481 12.2384 13.7553 12.1678 13.5816C12.0971 13.4079 11.9671 13.2643 11.8004 13.1761C11.5582 13.0389 11.336 12.8697 11.1399 12.673C10.7945 12.3246 10.5342 11.9023 10.3792 11.4385C10.2242 10.9748 10.1786 10.482 10.2459 9.998C10.3614 9.26273 10.7148 8.58455 11.2527 8.06559L16.8911 2.47604C17.2311 2.13898 17.6429 1.8816 18.0962 1.72282C18.5496 1.56403 19.0331 1.50784 19.5112 1.55838C19.9893 1.60892 20.4499 1.76491 20.8593 2.01489C21.2687 2.26487 21.6165 2.60251 21.8771 3.00307C22.2757 3.63292 22.4442 4.37918 22.3548 5.11738C22.2654 5.85557 21.9234 6.54106 21.3858 7.05948L16.3192 12.0741C16.1676 12.2245 16.0824 12.4284 16.0824 12.641C16.0825 12.8537 16.1677 13.0576 16.3193 13.2079C16.471 13.3583 16.6767 13.4427 16.8912 13.4428C17.1057 13.4428 17.3114 13.3583 17.4631 13.208L22.5859 8.12149C23.072 7.63928 23.4487 7.0598 23.6908 6.42175C23.9329 5.7837 24.0349 5.10178 23.9899 4.42154C23.9449 3.7413 23.754 3.07841 23.43 2.47715C23.1059 1.87589 22.6562 1.3501 22.1107 0.93492C21.1498 0.243522 19.97 -0.0820695 18.7869 0.0176244C17.6037 0.117318 16.4962 0.635652 15.6668 1.47792L10.117 6.90776C9.20947 7.78062 8.67438 8.96536 8.62193 10.2178C8.56948 11.4701 9.00363 12.6948 9.83501 13.6392Z"
                  fill="#222"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="24" height="24" fill="#222" />
                </clipPath>
              </defs>
            </svg>
            <span>My Joins</span>
          </a>
        </li>
        <hr />
        <!-- Management -->
        <template
          v-if="
            hasDashboardPublishings ||
              hasDashboardBlog ||
              hasDashboardAdmin ||
              hasDashboardCompany ||
              hasDashboardDeveloper
          "
        >
          <!-- Publishings -->
          <li
            v-if="hasDashboardPublishings"
            class="li-link"
            @click="handleMyPublishingsClick"
            :class="{ active: $route.path == '/manage/platform' }"
          >
            <a>
              <img src="@/assets/literature-24.png" /> &nbsp;&nbsp;
              <span class="menu">Publisher Platform</span>
            </a>
          </li>
          <!-- Blog Management -->
          <li
            v-if="hasDashboardBlog"
            class="li-link manage-div"
            @click="handleDashboardManageBlogClick"
            :class="{ active: $route.path == '/manage/blog' }"
          >
            <a>
              <img src="@/assets/blog-24.png" /> &nbsp;&nbsp;
              <span class="menu">Blog Management</span>
            </a>
          </li>
          <!-- Admin Management -->
          <li
            v-if="hasDashboardAdmin"
            class="li-link manage-div"
            @click="handleDashboardAdminClick"
            :class="{ active: $route.path == '/manage/admin' }"
          >
            <a>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.5 9.72656L20.5781 9.30469C20.4375 8.85156 20.25 8.39062 20.0156 7.92188L21.0469 6.1875C21.1875 5.96875 21.293 5.73828 21.3633 5.49609C21.4336 5.25391 21.4453 5 21.3984 4.73438C21.3516 4.46875 21.2344 4.24219 21.0469 4.05469L19.9922 3C19.8516 2.85938 19.6836 2.75391 19.4883 2.68359C19.293 2.61328 19.0977 2.58203 18.9023 2.58984C18.707 2.59766 18.5156 2.63281 18.3281 2.69531C18.1406 2.75781 17.9688 2.83594 17.8125 2.92969L16.125 4.00781L15.9375 3.91406L15.75 3.82031L15.5625 3.73828L15.3633 3.65625L15.1641 3.57422L14.9648 3.50391L14.7656 3.44531L14.3438 1.47656C14.2656 1.10156 14.0781 0.761719 13.7812 0.457031C13.4844 0.152344 13.1406 0 12.75 0H11.25C10.8594 0 10.5352 0.148438 10.2773 0.445312C10.0195 0.742188 9.84375 1.09375 9.75 1.5L9.25781 3.42188C9.00781 3.5 8.76172 3.58984 8.51953 3.69141C8.27734 3.79297 8.03906 3.90625 7.80469 4.03125L6.07031 2.92969C5.86719 2.78906 5.63672 2.69141 5.37891 2.63672C5.12109 2.58203 4.85938 2.58203 4.59375 2.63672C4.32812 2.69141 4.10156 2.8125 3.91406 3L2.83594 4.05469C2.57031 4.39844 2.44922 4.75 2.47266 5.10938C2.49609 5.46875 2.61719 5.82812 2.83594 6.1875L3.9375 8.01562C3.71875 8.46875 3.54688 8.89844 3.42188 9.30469L1.5 9.72656C1.10938 9.80469 0.761719 9.98828 0.457031 10.2773C0.152344 10.5664 0 10.9141 0 11.3203V12.8203C0 13.1953 0.148438 13.5156 0.445312 13.7812C0.742188 14.0469 1.09375 14.2266 1.5 14.3203L3.44531 14.7891C3.57031 15.1797 3.73438 15.5781 3.9375 15.9844L2.83594 17.8125C2.61719 18.1719 2.49609 18.5312 2.47266 18.8906C2.44922 19.25 2.57031 19.6016 2.83594 19.9453L3.91406 21C4.22656 21.2812 4.58594 21.418 4.99219 21.4102C5.39844 21.4023 5.75781 21.2891 6.07031 21.0703L7.80469 19.9688L8.08594 20.1094L8.37891 20.2383L8.68359 20.3555L8.98828 20.4727L9.28125 20.5781L9.75 22.5C9.84375 22.9062 10.0234 23.2578 10.2891 23.5547C10.5547 23.8516 10.875 24 11.25 24H12.75C13.0156 24 13.2656 23.9258 13.5 23.7773C13.7344 23.6289 13.9219 23.4414 14.0625 23.2148C14.2031 22.9883 14.2969 22.75 14.3438 22.5L14.7656 20.5547C15.2344 20.4141 15.6875 20.2266 16.125 19.9922L17.8125 21.0703C18.1406 21.2891 18.5078 21.4023 18.9141 21.4102C19.3203 21.418 19.6797 21.2812 19.9922 21L21.0469 19.9453C21.3125 19.6016 21.4336 19.25 21.4102 18.8906C21.3867 18.5312 21.2656 18.1719 21.0469 17.8125L20.0156 16.0781C20.2344 15.6562 20.4141 15.2266 20.5547 14.7891L22.5 14.3203C22.9062 14.2266 23.2578 14.0469 23.5547 13.7812C23.8516 13.5156 24 13.1953 24 12.8203V11.3203C24 10.7109 23.6797 10.2422 23.0391 9.91406C22.8672 9.82031 22.6875 9.75781 22.5 9.72656ZM22.5 12.7031C22.4844 12.7188 22.4609 12.7344 22.4297 12.75C22.3984 12.7656 22.3594 12.7812 22.3125 12.7969L22.1719 12.8438L19.3828 13.5469L19.125 14.3203C19.0625 14.5078 18.9961 14.6914 18.9258 14.8711C18.8555 15.0508 18.7734 15.2266 18.6797 15.3984L18.3047 16.1484L19.7812 18.5859C19.8594 18.7266 19.9062 18.8516 19.9219 18.9609L18.9375 19.9453C18.875 19.9297 18.8203 19.9102 18.7734 19.8867C18.7266 19.8633 18.6953 19.8438 18.6797 19.8281L16.2188 18.2578L15.4453 18.6562C15.3203 18.7188 15.1953 18.7773 15.0703 18.832L14.6953 18.9961L14.3203 19.125L13.5 19.4062L12.8906 22.1953C12.875 22.2578 12.8516 22.3164 12.8203 22.3711C12.7891 22.4258 12.7578 22.4688 12.7266 22.5H11.3672C11.3047 22.4062 11.2578 22.2969 11.2266 22.1719L10.5234 19.4062L9.72656 19.1484C9.67969 19.1328 9.63672 19.1172 9.59766 19.1016C9.55859 19.0859 9.51562 19.0703 9.46875 19.0547L9.32812 19.0078L9.1875 18.9492L9.04688 18.8906L8.90625 18.832L8.77734 18.7734L8.64844 18.7148L8.50781 18.6328L7.73438 18.2344L5.27344 19.8047C5.16406 19.8828 5.0625 19.9219 4.96875 19.9219L3.98438 18.9609C4 18.8516 4.04688 18.7344 4.125 18.6094L5.64844 16.0547L5.29688 15.3281C5.125 14.9844 4.98438 14.6562 4.875 14.3438L4.61719 13.5469L1.875 12.8438C1.71875 12.8125 1.59375 12.7656 1.5 12.7031V11.3203C1.51562 11.3203 1.53516 11.3125 1.55859 11.2969C1.58203 11.2812 1.61328 11.2617 1.65234 11.2383C1.69141 11.2148 1.72656 11.2031 1.75781 11.2031L4.59375 10.5703L4.85156 9.75C4.94531 9.42188 5.08594 9.0625 5.27344 8.67188L5.64844 7.94531L4.125 5.41406C4.09375 5.35156 4.0625 5.28516 4.03125 5.21484C4 5.14453 3.98438 5.08594 3.98438 5.03906L4.96875 4.05469L5.22656 4.17188L7.73438 5.76562L8.50781 5.36719C8.89844 5.16406 9.30469 4.99219 9.72656 4.85156L10.5234 4.59375L11.2031 1.875C11.2344 1.71875 11.2891 1.59375 11.3672 1.5H12.75L12.7734 1.57031C12.7891 1.58594 12.8008 1.60156 12.8086 1.61719C12.8164 1.63281 12.8242 1.65625 12.832 1.6875C12.8398 1.71875 12.8516 1.74219 12.8672 1.75781L13.4766 4.59375L14.2969 4.875C14.6875 5 15.0703 5.15625 15.4453 5.34375L16.2188 5.74219L18.6328 4.19531C18.7422 4.13281 18.8438 4.10156 18.9375 4.10156L19.9219 5.0625C19.9062 5.09375 19.8906 5.14062 19.875 5.20312C19.8594 5.26562 19.8281 5.32812 19.7812 5.39062L18.3047 7.85156L18.6797 8.60156C18.7891 8.80469 18.8828 9 18.9609 9.1875C19.0391 9.375 19.1016 9.5625 19.1484 9.75L19.4062 10.5703L22.1953 11.2031C22.3672 11.2344 22.4766 11.2891 22.5234 11.3672L22.5 12.7031ZM12.0117 7.5C10.7695 7.5 9.70703 7.9375 8.82422 8.8125C7.94141 9.6875 7.5 10.75 7.5 12C7.5 13.25 7.94141 14.3125 8.82422 15.1875C9.70703 16.0625 10.7656 16.5 12 16.5C12.625 16.5 13.2148 16.3828 13.7695 16.1484C14.3242 15.9141 14.8047 15.5938 15.2109 15.1875C15.6172 14.7812 15.9375 14.3008 16.1719 13.7461C16.4062 13.1914 16.5234 12.6094 16.5234 12C16.5234 10.75 16.082 9.6875 15.1992 8.8125C14.3164 7.9375 13.2539 7.5 12.0117 7.5ZM12 15C11.1719 15 10.4648 14.707 9.87891 14.1211C9.29297 13.5352 9 12.8281 9 12C9 11.1719 9.29297 10.4648 9.87891 9.87891C10.4648 9.29297 11.1719 9 12 9C12.8281 9 13.5352 9.29297 14.1211 9.87891C14.707 10.4648 15 11.1719 15 12C15 12.8281 14.707 13.5352 14.1211 14.1211C13.5352 14.707 12.8281 15 12 15Z"
                  fill="#222"
                />
              </svg>
              <span class="menu">Admin Management</span>
            </a>
          </li>
          <!-- Company Management -->
          <li
            v-if="hasDashboardCompany"
            class="li-link"
            @click="handleDashboardCompanyClick"
            :class="{ active: $route.path == '/manage/company' }"
          >
            <a>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0)">
                  <path
                    d="M1.38519 22.5984C1.88674 23.0951 2.49233 23.4763 3.15912 23.7151C3.8259 23.9538 4.53751 24.0442 5.24347 23.9798C6.42321 23.8511 7.52029 23.3172 8.34454 22.4706L13.7334 17.1286C14.5006 16.3879 15.0205 15.4321 15.2235 14.3897C15.4164 13.403 15.2859 12.381 14.8512 11.4731C14.4164 10.5651 13.7001 9.81882 12.807 9.34317C12.7016 9.28261 12.5837 9.24652 12.4622 9.23764C12.3408 9.22876 12.2189 9.2473 12.1057 9.29189C11.9925 9.33647 11.8909 9.40592 11.8087 9.49502C11.7265 9.58412 11.6658 9.69054 11.631 9.80629C11.5781 9.98802 11.5919 10.1825 11.6701 10.3551C11.7482 10.5276 11.8857 10.6671 12.0579 10.7485C12.5936 11.0396 13.0348 11.4757 13.33 12.0058C13.6252 12.536 13.7623 13.1385 13.7253 13.7429C13.6554 14.5819 13.277 15.3663 12.662 15.9468L7.20085 21.3607C6.61069 21.94 5.82738 22.2857 4.99821 22.3327C4.16905 22.3798 3.35108 22.125 2.69809 21.6162C2.30909 21.2764 2.00862 20.8485 1.82212 20.3689C1.63561 19.8893 1.56864 19.3721 1.62685 18.8614C1.7257 18.0927 2.08994 17.3817 2.6578 16.8491L7.6841 11.8664C7.83412 11.7168 7.91833 11.5145 7.91833 11.3035C7.91833 11.0925 7.83412 10.8902 7.6841 10.7405C7.53318 10.5918 7.32901 10.5083 7.11621 10.5083C6.9034 10.5083 6.69923 10.5918 6.54832 10.7405L1.55433 15.6913C0.697933 16.5076 0.156514 17.5952 0.0238599 18.7656C-0.0464324 19.4643 0.0390413 20.1698 0.274283 20.8321C0.509525 21.4945 0.888812 22.0975 1.38519 22.5984Z"
                    fill="#222"
                  />
                  <path
                    d="M9.83501 13.6392C10.1872 14.0177 10.5978 14.3384 11.0514 14.5894C11.1552 14.6425 11.2694 14.6727 11.3861 14.6777C11.5029 14.6827 11.6192 14.6624 11.7273 14.6184C11.8354 14.5743 11.9324 14.5075 12.0118 14.4225C12.0912 14.3375 12.151 14.2365 12.1871 14.1263C12.2453 13.9481 12.2384 13.7553 12.1678 13.5816C12.0971 13.4079 11.9671 13.2643 11.8004 13.1761C11.5582 13.0389 11.336 12.8697 11.1399 12.673C10.7945 12.3246 10.5342 11.9023 10.3792 11.4385C10.2242 10.9748 10.1786 10.482 10.2459 9.998C10.3614 9.26273 10.7148 8.58455 11.2527 8.06559L16.8911 2.47604C17.2311 2.13898 17.6429 1.8816 18.0962 1.72282C18.5496 1.56403 19.0331 1.50784 19.5112 1.55838C19.9893 1.60892 20.4499 1.76491 20.8593 2.01489C21.2687 2.26487 21.6165 2.60251 21.8771 3.00307C22.2757 3.63292 22.4442 4.37918 22.3548 5.11738C22.2654 5.85557 21.9234 6.54106 21.3858 7.05948L16.3192 12.0741C16.1676 12.2245 16.0824 12.4284 16.0824 12.641C16.0825 12.8537 16.1677 13.0576 16.3193 13.2079C16.471 13.3583 16.6767 13.4427 16.8912 13.4428C17.1057 13.4428 17.3114 13.3583 17.4631 13.208L22.5859 8.12149C23.072 7.63928 23.4487 7.0598 23.6908 6.42175C23.9329 5.7837 24.0349 5.10178 23.9899 4.42154C23.9449 3.7413 23.754 3.07841 23.43 2.47715C23.1059 1.87589 22.6562 1.3501 22.1107 0.93492C21.1498 0.243522 19.97 -0.0820695 18.7869 0.0176244C17.6037 0.117318 16.4962 0.635652 15.6668 1.47792L10.117 6.90776C9.20947 7.78062 8.67438 8.96536 8.62193 10.2178C8.56948 11.4701 9.00363 12.6948 9.83501 13.6392Z"
                    fill="#222"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="24" height="24" fill="#222" />
                  </clipPath>
                </defs>
              </svg>
              <span>Company Portal</span>
            </a>
          </li>
          <!-- Developer Management -->
          <li
            v-if="hasDashboardDeveloper"
            class="li-link"
            @click="handleDashboardDeveloperClick"
            :class="{ active: $route.path === '/manage/developer' }"
          >
            <a>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0)">
                  <path
                    d="M1.38519 22.5984C1.88674 23.0951 2.49233 23.4763 3.15912 23.7151C3.8259 23.9538 4.53751 24.0442 5.24347 23.9798C6.42321 23.8511 7.52029 23.3172 8.34454 22.4706L13.7334 17.1286C14.5006 16.3879 15.0205 15.4321 15.2235 14.3897C15.4164 13.403 15.2859 12.381 14.8512 11.4731C14.4164 10.5651 13.7001 9.81882 12.807 9.34317C12.7016 9.28261 12.5837 9.24652 12.4622 9.23764C12.3408 9.22876 12.2189 9.2473 12.1057 9.29189C11.9925 9.33647 11.8909 9.40592 11.8087 9.49502C11.7265 9.58412 11.6658 9.69054 11.631 9.80629C11.5781 9.98802 11.5919 10.1825 11.6701 10.3551C11.7482 10.5276 11.8857 10.6671 12.0579 10.7485C12.5936 11.0396 13.0348 11.4757 13.33 12.0058C13.6252 12.536 13.7623 13.1385 13.7253 13.7429C13.6554 14.5819 13.277 15.3663 12.662 15.9468L7.20085 21.3607C6.61069 21.94 5.82738 22.2857 4.99821 22.3327C4.16905 22.3798 3.35108 22.125 2.69809 21.6162C2.30909 21.2764 2.00862 20.8485 1.82212 20.3689C1.63561 19.8893 1.56864 19.3721 1.62685 18.8614C1.7257 18.0927 2.08994 17.3817 2.6578 16.8491L7.6841 11.8664C7.83412 11.7168 7.91833 11.5145 7.91833 11.3035C7.91833 11.0925 7.83412 10.8902 7.6841 10.7405C7.53318 10.5918 7.32901 10.5083 7.11621 10.5083C6.9034 10.5083 6.69923 10.5918 6.54832 10.7405L1.55433 15.6913C0.697933 16.5076 0.156514 17.5952 0.0238599 18.7656C-0.0464324 19.4643 0.0390413 20.1698 0.274283 20.8321C0.509525 21.4945 0.888812 22.0975 1.38519 22.5984Z"
                    fill="#222"
                  />
                  <path
                    d="M9.83501 13.6392C10.1872 14.0177 10.5978 14.3384 11.0514 14.5894C11.1552 14.6425 11.2694 14.6727 11.3861 14.6777C11.5029 14.6827 11.6192 14.6624 11.7273 14.6184C11.8354 14.5743 11.9324 14.5075 12.0118 14.4225C12.0912 14.3375 12.151 14.2365 12.1871 14.1263C12.2453 13.9481 12.2384 13.7553 12.1678 13.5816C12.0971 13.4079 11.9671 13.2643 11.8004 13.1761C11.5582 13.0389 11.336 12.8697 11.1399 12.673C10.7945 12.3246 10.5342 11.9023 10.3792 11.4385C10.2242 10.9748 10.1786 10.482 10.2459 9.998C10.3614 9.26273 10.7148 8.58455 11.2527 8.06559L16.8911 2.47604C17.2311 2.13898 17.6429 1.8816 18.0962 1.72282C18.5496 1.56403 19.0331 1.50784 19.5112 1.55838C19.9893 1.60892 20.4499 1.76491 20.8593 2.01489C21.2687 2.26487 21.6165 2.60251 21.8771 3.00307C22.2757 3.63292 22.4442 4.37918 22.3548 5.11738C22.2654 5.85557 21.9234 6.54106 21.3858 7.05948L16.3192 12.0741C16.1676 12.2245 16.0824 12.4284 16.0824 12.641C16.0825 12.8537 16.1677 13.0576 16.3193 13.2079C16.471 13.3583 16.6767 13.4427 16.8912 13.4428C17.1057 13.4428 17.3114 13.3583 17.4631 13.208L22.5859 8.12149C23.072 7.63928 23.4487 7.0598 23.6908 6.42175C23.9329 5.7837 24.0349 5.10178 23.9899 4.42154C23.9449 3.7413 23.754 3.07841 23.43 2.47715C23.1059 1.87589 22.6562 1.3501 22.1107 0.93492C21.1498 0.243522 19.97 -0.0820695 18.7869 0.0176244C17.6037 0.117318 16.4962 0.635652 15.6668 1.47792L10.117 6.90776C9.20947 7.78062 8.67438 8.96536 8.62193 10.2178C8.56948 11.4701 9.00363 12.6948 9.83501 13.6392Z"
                    fill="#222"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="24" height="24" fill="#222" />
                  </clipPath>
                </defs>
              </svg>
              <span>Developer Portal</span>
            </a>
          </li>
        </template>
      </ul>
      <!-- CReate Focus -->
    </div>
  </div>
</template>

<script>
import createFocus from "@/components/jab/createFocus";
import config from "@/assets/_config.json";
import { mapGetters } from "vuex";
export default {
  name: "",
  data() {
    return {
      config,
      addFocus: "create-focus",
      refreshKey: 1
    };
  },
  components: {
    createFocus
  },
  computed: {
    ...mapGetters({
      focuses: "user/focuses",
      user: "user/user",
      profile: "user/profile"
    }),
    hasMyJoins() {
      return true;
      // return this.profile._stats && this.profile._stats.joins > 0;
    },
    hasDashboardAdmin() {
      return (
        this.profile &&
        this.profile._dashboards &&
        this.profile._dashboards.admin &&
        this.profile._dashboards.admin._account &&
        this.profile._dashboards.admin._account.status === "active"
      );
    },
    hasDashboardPublishings() {
      return (
        this.profile &&
        this.profile._dashboards &&
        this.profile._dashboards.guide &&
        this.profile._dashboards.guide &&
        this.profile._dashboards.guide._account.status === "active"
      );
    },
    hasDashboardBlog() {
      return (
        this.profile &&
        this.profile._dashboards &&
        this.profile._dashboards.blogger &&
        this.profile._dashboards.blogger._account &&
        this.profile._dashboards.blogger._account.status === "active"
      );
    },
    hasDashboardCompany() {
      return (
        this.profile &&
        this.profile._dashboards &&
        this.profile._dashboards.company &&
        this.profile._dashboards.company._account &&
        this.profile._dashboards.company._account.status === "active"
      );
    },
    hasDashboardDeveloper() {
      return (
        this.profile &&
        this.profile._dashboards &&
        this.profile._dashboards.developer &&
        this.profile._dashboards.developer._account &&
        this.profile._dashboards.developer._account.status === "active"
      );
    }
  },
  methods: {
    handleGoHomeClick() {
      const route = "/";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleGoToCornershelfClick() {
      const route = "/app/myapps";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleGoToMatchGameClick() {
      const route = "/games/match_game";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleGoToSimonGameClick() {
      const route = "/games/simon_game";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleGoToSliderGameClick() {
      const route = "/games/slider_game";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleGoToTicTacToeClick() {
      const route = "/games/tic_tac_toe";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleGoToPhraseGameClick() {
      const route = "/games/phrase_game";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleGoToPhotoAlbumClick() {
      const route = "/services/photo_album";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleDiscoverClick() {
      const route = "/app/library";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleBlogClick() {
      const route = "/app/blog";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    createFocus() {
      this.$store.dispatch("setSetting", {
        setting: "showFocusSelectSessionType",
        value: true
      });
    },
    hideSidebar() {
      this.$emit("hideSidebar");
    },
    showSidebar() {
      this.$emit("showSidebar");
    },
    handleMyPublishingsClick() {
      const route = "/manage/platform";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleDashboardAdminClick() {
      const route = "/manage/admin";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleDashboardGuideClick() {
      const route = "/manage/crew-profile";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
    handleDashboardManageBlogClick() {
      const route = "/manage/blog";
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.menu {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  display: flex;
  align-items: center;

  /* Body */

  color: #222222;
}
.sidebar {
  min-height: 100vh;
  background-color: var(--theme-color);
  position: relative;
  width: 234px;
  .sidebar__inner {
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    height: 100%;
    width: inherit;
    background-color: inherit;
  }
  .small-logo {
    display: none;
  }
  .large-logo {
    display: block;
  }
  .show-icon {
    display: none;
  }
  .logo {
    padding: 20px 10px 20px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .hide-icon,
  .show-icon {
    cursor: pointer;
    svg {
      path:nth-child(2) {
        opacity: 0.8;
        transition: opacity 0.3s ease;
      }
    }
  }
  .hide-icon:hover,
  .show-icon:hover {
    svg {
      path {
        opacity: 1;
      }
    }
  }
  .text-sm {
    margin-top: 20px;
    color: var(--theme-contrast-text);
    font-family: "Nunito", sans-serif;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    padding: 10px 10px 10px 24px;
  }
  .sidebar-nav {
    margin-top: 56px;
    list-style-type: none;
    padding: 0;
    li {
      cursor: pointer;
      display: block;
      padding: 10px 15px 10px 24px;
      a {
        font-style: normal;
        font-size: 16px;
        line-height: 22px;
        text-transform: capitalize;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-family: "Nunito", sans-serif;
        font-weight: 500;
        text-decoration: none;
        color: var(--theme-contrast-text);
        svg {
          margin-right: 10px;
        }
      }
      &.li-link {
        &:hover,
        &.active {
          background-color: rgba(
            $color: var(--theme-contrast-text),
            $alpha: 0.1
          );
          border-right: 4px solid var(--theme-contrast-text);
        }
      }
    }
    .li-btn {
      padding: 0 10px 0 24px;
    }
    .white-btn {
      background-color: var(--theme-contrast-text);
      border: 1px solid var(--theme-contrast-text) fff;
      padding: 6px 30px;
      color: var(--theme-color);
      border-radius: 10px;
      margin-top: 10px;
      margin-bottom: 10px;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      margin-left: 5%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

@media (max-width: 1440px) {
  .sidebar {
    // position: fixed;
    // z-index: 8;
    // left: 0;
    // top: 0;
    // height: 100vh;
    // width: 234px;
  }
}

.sidebar.small {
  width: 60px;
  /*position: unset;*/
  .text-sm {
    padding: 5px;
    text-align: center;
  }
  .li-link {
    &:hover,
    &.active {
      border-right: none !important;
    }
  }

  .logo {
    padding: 5px;
    justify-content: center;
    padding-top: 10px;
    .hide-icon {
      display: none;
    }
    .large-logo {
      display: none;
    }
    .small-logo {
      display: block;
    }
    .show-icon {
      display: block;
    }
  }
  li {
    padding: 5px;
    a {
      svg {
        margin: 0 auto;
      }
      span {
        display: none;
      }
    }
  }
  .li-btn {
    margin: 0;
    padding: 5px;
    button {
      padding: 5px !important;
      margin: 5px auto;
      span {
        display: none;
      }
    }
  }
}
</style>
